import { ModelRow, ModelRowType, UserSettings, UserSettingsDef } from "@mcleod/core";

export interface LMEUserSettingsDef extends UserSettingsDef {
    //auth
    all_contacts: string;
    asset_new_order_next_action: string;
    bp_profile: string;
    bp_profile2: string;
    bp_profile3: string;
    bp_profile4: string;
    call_list_profile: string;
    carrier_call_list_id: string;
    daily_advance_limits: string;
    default_dispatch_layout: string;
    def_move_type: string;
    driver_manager_profile: string;
    driver_manager_profile2: string;
    driver_manager_profile3: string;
    driver_manager_profile4: string;
    detention_profile: string;
    ltl_quote_template: number;
    margin_percentage: string;
    new_order_next_action: string;
    order_planning_profile: string;
    order_planning_profile2: string;
    order_planning_profile3: string;
    order_planning_profile4: string;
	quote_comp_act_create: string;
	quote_pend_act_create: string;
    quote_template: number;
    show_google_route: string;
    show_proposed_route: string;
    tm_profile: string;
    trimble_map_traffic: string;
    csm_profile: string;
    csm_profile2: string;
    csm_profile3: string;
    csm_profile4: string;
    type_agents: string;
    type_carrier: string;
    type_company_drs: string;
    type_owner_oper: string;
    invoice_processing_profile: string;
    invoice_processing_profile2: string;
    invoice_processing_profile3: string;
    invoice_processing_profile4: string;
    order_payables_profile: string;
    order_payables_profile2: string;
    order_payables_profile3: string;
    order_payables_profile4: string;
    driver_settlement_profile: string;
    driver_settlement_profile2: string;
    driver_settlement_profile3: string;
    driver_settlement_profile4: string;
    office_payroll_profile: string;
    office_payroll_profile2: string;
    office_payroll_profile3: string;
    office_payroll_profile4: string;
    collections_profile: string;
    collections_profile2: string;
    collections_profile3: string;
    collections_profile4: string;
    manifest_profile: string;
}

export class LMEUserSettings extends UserSettings {
    public static getSingleton(): LMEUserSettings {
        return UserSettings.getSingleton() as LMEUserSettings;
    }

    public static get(): LMEUserSettingsDef {
        return LMEUserSettings.getSingleton().values as LMEUserSettingsDef;
    }

    public override get values(): LMEUserSettingsDef {
        return super.values as LMEUserSettingsDef;
    }

    protected getValuesInternal(): LMEUserSettingsDef {
        return this._values as LMEUserSettingsDef;
    }

    public static getUserLookupModelData() {
        const userId = LMEUserSettings.getUserId();
        const userName = LMEUserSettings.getUserName();
        const lmData = new ModelRow("common/users", false, {
            id: userId,
            name: userName
        });
        lmData.type = ModelRowType.LOOKUP_MODEL_DATA;
        return lmData;
    }

    public static setUserLookupModelData(field: string, modelRow: ModelRow) {
        const lmData = LMEUserSettings.getUserLookupModelData();
        const userId = LMEUserSettings.getUserId();
        modelRow.setLookupModelData(field, lmData);
        modelRow.set(field, userId);
    }
}
